import utilUrl from './url';
import { isFunction } from './typeof';
import * as utilUa from './ua';
import utilWx from './wx';
import { backToPreviousPage } from '../native';
import Detector from './detector';


const location = window.location;
const zzc = window.zzc;

export function push(url, query = {}, isReload = false) {
  url = utilUrl.parse(url, true);
  url.query = { ...url.query, ...query };
  delete url.search;
  url = utilUrl.format(url);

  if (isReload) {
    location.reload(url);
    return;
  }

  location.href = url;
}


export function home() {
  if (utilUa.isWebchatMiniprogram()) {
    utilWx.miniProgram.switchTab({
      url: '/pages/index/index'
    });
  }
  // TODO
}

export const h5Back = () => {
  if (window.history.length > 0) {
    window.history.go(-1);
  } else {
    window.location.href = '/';
  }
};

export function back(step, cb) {
  const _step = step ? Number(step) : -1;
  if (Detector.browser.name === 'zuzuche') {
    zzc.call('base_goBackPage', {
      step: _step,
      success(response) {
        isFunction(cb) && cb(response);
      }
    });
  } else {
    window.history.go(_step);
  }
}

export const goBack = () => {
  if (utilUa.isHostApp()) {
    backToPreviousPage();
    return;
  }
  h5Back();
};
